import { render } from "./SuggestedPreview.vue?vue&type=template&id=8e0fca98"
import script from "./SuggestedPreview.vue?vue&type=script&lang=js"
export * from "./SuggestedPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__